import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "connectBoxFilled"
const ConnectBoxFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M7.125 8.25C7.332 8.25 7.5 8.418 7.5 8.625V9.75H18.75L18.866 9.753C20.055 9.813 21 10.796 21 12V19.5C21 20.704 20.055 21.687 18.866 21.747L18.75 21.75H3.75C2.507 21.75 1.5 20.743 1.5 19.5V12C1.5 10.757 2.507 9.75 3.75 9.75V8.625C3.75 8.418 3.918 8.25 4.125 8.25zM4.125 17.25C3.918 17.25 3.75 17.418 3.75 17.625V18.375C3.75 18.582 3.918 18.75 4.125 18.75H9.375C9.582 18.75 9.75 18.582 9.75 18.375V17.625C9.75 17.418 9.582 17.25 9.375 17.25zM14.625 17.25C14.418 17.25 14.25 17.418 14.25 17.625V18.375C14.25 18.582 14.418 18.75 14.625 18.75H15.375C15.582 18.75 15.75 18.582 15.75 18.375V17.625C15.75 17.418 15.582 17.25 15.375 17.25zM16.875 17.25C16.668 17.25 16.5 17.418 16.5 17.625V18.375C16.5 18.582 16.668 18.75 16.875 18.75H17.625C17.832 18.75 18 18.582 18 18.375V17.625C18 17.418 17.832 17.25 17.625 17.25z"
            clipRule="evenodd"
          />
          <path d="M13.1 6.122C14.148 5.6 15.325 5.394 16.486 5.532 17.647 5.667 18.744 6.141 19.64 6.893 19.957 7.16 19.998 7.634 19.732 7.95 19.466 8.268 18.992 8.31 18.675 8.043 18.003 7.479 17.181 7.123 16.31 7.02S14.556 7.073 13.77 7.465C13.401 7.65 12.95 7.498 12.765 7.128S12.73 6.308 13.1 6.122M14.528 2.078C15.49 1.865 16.484 1.844 17.454 2.015S19.351 2.546 20.181 3.075C21.011 3.605 21.731 4.293 22.295 5.1 22.532 5.44 22.45 5.907 22.11 6.144 21.771 6.382 21.303 6.3 21.066 5.96 20.614 5.314 20.039 4.764 19.375 4.34S17.969 3.628 17.194 3.491 15.622 3.372 14.853 3.543 13.355 4.033 12.71 4.485C12.37 4.723 11.903 4.64 11.665 4.301 11.428 3.96 11.511 3.494 11.85 3.256 12.657 2.692 13.567 2.291 14.528 2.078" />
        </svg>
      }
    </span>
  )
}
export default ConnectBoxFilledIcon
